import React, { useState, useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import { API_URL } from "../../constant";
import "../../components/Customer/CaptainTCCard.css";

const CaptainTCGoldCard = () => {
  const { userData } = useOutletContext();
  const [formData, setFormData] = useState({
    retailBusinessNo: "",
    cardNumber: "",
    serialNumber: "",
  });
  const [statusMessage, setStatusMessage] = useState("");
  const [registeredCards, setRegisteredCards] = useState([]);
  
  // Pagination State
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  // Derived state for pagination
  const totalPages = Math.ceil(registeredCards.length / itemsPerPage);
  const currentCards = registeredCards.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  useEffect(() => {
    fetchEntries();
  }, []);

  const fetchEntries = async () => {
    try {
      const token = localStorage.getItem("auth_token");
      const response = await fetch(`${API_URL}/api/customer/captain-tc-gold-card/entries`, {
        headers: {
          "Authorization": `Bearer ${token}`
        }
      });
      
      const data = await response.json();
      if (response.ok && data.status) {
        setRegisteredCards(data.data);
      }
    } catch (error) {
      console.error("Error fetching entries:", error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    if (!formData.retailBusinessNo || !formData.cardNumber || !formData.serialNumber) {
      setStatusMessage("Please fill in all fields.");
      return;
    }
    
    try {
      const token = localStorage.getItem("auth_token");
      const response = await fetch(`${API_URL}/api/customer/captain-tc-gold-card/verify`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({
          retail_business_no: formData.retailBusinessNo,
          card_number: formData.cardNumber,
          serial_number: formData.serialNumber
        })
      });
      
      const data = await response.json();
      
      if (response.ok && data.status) {
        setStatusMessage("Valid: Card registered successfully.");
        setFormData({ retailBusinessNo: "", cardNumber: "", serialNumber: "" });
        fetchEntries(); // Refresh the list from the new table
      } else {
        setStatusMessage(data.message || "Invalid: Match not found.");
        fetchEntries(); // Refresh the list to show the Invalid entry
      }
    } catch (error) {
      console.error("Error verifying card:", error);
      setStatusMessage("Error verifying card details.");
    }
  };

  return (
    <div className="captain-tc-wrapper">
      
      {/* Informational Content (Replicating DOCX) - Compact Version */}
      <div style={{ backgroundColor: "#fff", borderRadius: "8px", padding: "15px", marginBottom: "20px", display: "flex", flexDirection: "column", gap: "15px", border: "1px solid #eaeaea", boxShadow: "0 2px 8px rgba(0,0,0,0.05)" }}>
        
        {/* Banner Section */}
        <div style={{ textAlign: "center", display: "flex", justifyContent: "center", alignItems: "center", gap: "15px", flexWrap: "wrap" }}>
          <h2 style={{ color: "#001964", fontSize: "24px", fontWeight: "bold", margin: 0, fontFamily: "serif" }}>CAPTAIN TC</h2>
          <span style={{ borderLeft: "1px solid #d4af37", borderRight: "1px solid #d4af37", padding: "0 15px", color: "#d4af37", letterSpacing: "2px", fontSize: "16px", fontWeight: "600" }}>★ GOLD CARD ★</span>
          <span style={{ letterSpacing: "2px", fontSize: "12px", color: "#555", textTransform: "uppercase" }}>Collect • Register • Redeem</span>
        </div>

        <div style={{ display: "flex", flexWrap: "wrap", gap: "15px" }}>
          {/* How It Works Section */}
          <div style={{ flex: "2", minWidth: "300px", border: "1px solid #eaeaea", padding: "16px", borderRadius: "6px", backgroundColor: "#fff" }}>
            <h6 style={{ textAlign: "center", color: "#001964", borderBottom: "1px solid #eaeaea", paddingBottom: "8px", marginBottom: "15px", letterSpacing: "1px", fontSize: "15px", margin: "0 0 15px 0" }}>HOW IT WORKS</h6>
            
            {/* Added overflowX: 'auto' and flexWrap: 'nowrap' to force single line scrolling on mobile */}
            <div style={{ display: "flex", flexWrap: "nowrap", overflowX: "auto", justifyContent: "space-between", alignItems: "flex-start", gap: "15px", textAlign: "center", paddingBottom: "10px" }}>
              <div style={{ flex: "1", minWidth: "120px" }}>
                <div style={{ fontSize: "28px", marginBottom: "6px" }}>👤</div>
                <div style={{ color: "#d4af37", fontSize: "14px", fontWeight: "bold", marginBottom: "4px" }}>COLLECT</div>
                <div style={{ fontSize: "13px", color: "#666", lineHeight: "1.3" }}>Collect & register Captain TC Gold Cards.</div>
              </div>
              <div style={{ color: "#d4af37", fontSize: "18px", alignSelf: "center", flexShrink: 0 }}>➔</div>
              <div style={{ flex: "1", minWidth: "120px" }}>
                <div style={{ fontSize: "28px", marginBottom: "6px" }}>💳</div>
                <div style={{ color: "#d4af37", fontSize: "14px", fontWeight: "bold", marginBottom: "4px" }}>REGISTER</div>
                <div style={{ fontSize: "13px", color: "#666", lineHeight: "1.3" }}>Please go to your Captain TC Gold Wallet.</div>
              </div>
              <div style={{ color: "#d4af37", fontSize: "18px", alignSelf: "center", flexShrink: 0 }}>➔</div>
              <div style={{ flex: "1", minWidth: "120px" }}>
                <div style={{ fontSize: "28px", marginBottom: "6px" }}>🎁</div>
                <div style={{ color: "#d4af37", fontSize: "14px", fontWeight: "bold", marginBottom: "4px" }}>REDEEM</div>
                <div style={{ fontSize: "13px", color: "#666", lineHeight: "1.3" }}>Redeem at 20 cards for £16 reward.</div>
              </div>
              <div style={{ color: "#d4af37", fontSize: "18px", alignSelf: "center", flexShrink: 0 }}>➔</div>
              <div style={{ flex: "1", minWidth: "150px" }}>
                <div style={{ fontSize: "28px", marginBottom: "6px" }}>🏆</div>
                <div style={{ color: "#d4af37", fontSize: "14px", fontWeight: "bold", marginBottom: "4px" }}>GOLD REWARD</div>
                <div style={{ fontSize: "13px", color: "#666", lineHeight: "1.3" }}>Or collect 200 cards to claim 1 gram of gold and exclusive TopCoin rewards.</div>
              </div>
            </div>
          </div>

          {/* Your Choice - Your Reward Section */}
          <div style={{ flex: "1", minWidth: "300px", border: "1px solid #eaeaea", padding: "16px", borderRadius: "6px", backgroundColor: "#fff", display: "flex", flexDirection: "column" }}>
            <h6 style={{ textAlign: "center", color: "#001964", borderBottom: "1px solid #eaeaea", paddingBottom: "8px", marginBottom: "15px", letterSpacing: "1px", fontSize: "15px", margin: "0 0 15px 0" }}>YOUR CHOICE – YOUR REWARD</h6>
            <div style={{ display: "flex", justifyContent: "space-around", alignItems: "center", flex: "1", textAlign: "center", gap: "10px" }}>
              <div>
                <div style={{ color: "#d4af37", fontSize: "14px", fontWeight: "bold", marginBottom: "6px" }}>20 CARDS</div>
                <div style={{ fontSize: "36px", marginBottom: "6px" }}>🎁</div>
                <div style={{ color: "#001964", fontSize: "16px", fontWeight: "bold" }}>£16 REWARD</div>
              </div>
              <div style={{ padding: "6px 10px", border: "1px solid #d4af37", borderRadius: "50%", color: "#d4af37", fontSize: "12px", fontWeight: "bold" }}>OR</div>
              <div>
                <div style={{ color: "#d4af37", fontSize: "14px", fontWeight: "bold", marginBottom: "6px" }}>200 CARDS</div>
                <div style={{ fontSize: "36px", marginBottom: "6px" }}>🪙</div>
                <div style={{ color: "#001964", fontSize: "14px", fontWeight: "bold", lineHeight: "1.3" }}>1 GRAM OF GOLD<br/>+ TOPCOIN REWARDS</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="reward-promo-container" style={{ marginBottom: "24px" }}>
        <div className="reward-promo-header" style={{ borderBottom: "1px solid #eaeaea", paddingBottom: "15px", marginBottom: "20px" }}>
          <div className="reward-promo-title">
            <h3 style={{ margin: 0, color: "#333", fontSize: "20px", fontWeight: "600" }}>Captain TC Gold Card</h3>
            <span style={{ fontSize: "14px", color: "#666" }}>Enter Captain TC gold card details to verify and register</span>
          </div>
        </div>
        
        <form onSubmit={handleRegister}>
          <div style={{ display: "flex", gap: "20px", flexWrap: "wrap", marginBottom: "20px" }}>
            <div style={{ flex: "1", minWidth: "200px" }}>
              <label style={{ display: "block", marginBottom: "8px", fontSize: "14px", fontWeight: "600", color: "#555" }}>Retail Business No</label>
              <input 
                type="text" 
                name="retailBusinessNo"
                value={formData.retailBusinessNo}
                onChange={handleInputChange}
                style={{ width: "100%", padding: "10px 12px", border: "1px solid #ddd", borderRadius: "6px", fontSize: "14px" }}
                placeholder="e.g. 101"
               maxLength={255} />
            </div>
            <div style={{ flex: "1", minWidth: "200px" }}>
              <label style={{ display: "block", marginBottom: "8px", fontSize: "14px", fontWeight: "600", color: "#555" }}>Card Number</label>
              <input 
                type="text" 
                name="cardNumber"
                value={formData.cardNumber}
                onChange={handleInputChange}
                style={{ width: "100%", padding: "10px 12px", border: "1px solid #ddd", borderRadius: "6px", fontSize: "14px" }}
                placeholder="e.g. 1001"
               maxLength={255} />
            </div>
            <div style={{ flex: "1", minWidth: "200px" }}>
              <label style={{ display: "block", marginBottom: "8px", fontSize: "14px", fontWeight: "600", color: "#555" }}>Serial Number</label>
              <input 
                type="text" 
                name="serialNumber"
                value={formData.serialNumber}
                onChange={handleInputChange}
                style={{ width: "100%", padding: "10px 12px", border: "1px solid #ddd", borderRadius: "6px", fontSize: "14px" }}
                placeholder="e.g. 1001"
               maxLength={100} />
            </div>
          </div>
          
          <button type="submit" style={{
            padding: "10px 24px",
            backgroundColor: "#001964",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
            fontWeight: "600",
            fontSize: "14px"
          }}>
            Verify & Register
          </button>
        </form>
        {statusMessage && (
          <div style={{
            marginTop: "20px", 
            padding: "12px", 
            borderRadius: "6px", 
            backgroundColor: statusMessage.includes("Valid") ? "#e6f4ea" : "#fce8e6",
            color: statusMessage.includes("Valid") ? "#1e8e3e" : "#d93025",
            fontSize: "14px",
            fontWeight: "500"
          }}>
            {statusMessage}
          </div>
        )}
      </div>

      <div className="reward-promo-container">
        <div className="reward-promo-header">
          <div className="reward-promo-title">
            <h3>Registered Cards</h3>
          </div>
        </div>
        <div className="reward-promo-table-wrap">
          <table className="reward-promo-table">
            <thead>
              <tr>
                <th>#</th>
                <th>RETAIL BUSINESS NO</th>
                <th>CARD NUMBER</th>
                <th>SERIAL NUMBER</th>
                <th>STATUS</th>
              </tr>
            </thead>
            <tbody>
              {registeredCards.length === 0 ? (
                <tr>
                  <td colSpan="5" style={{ textAlign: "center", padding: "20px", color: "#666" }}>
                    No cards registered yet.
                  </td>
                </tr>
              ) : (
                currentCards.map((card, index) => (
                  <tr key={index}>
                    <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                    <td>{card.retail_business_no}</td>
                    <td>{card.card_number}</td>
                    <td>{card.serial_number}</td>
                    <td>
                      <span className={card.status === "Valid" ? "badge-yes" : "badge-no"}>
                        {card.status}
                      </span>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        
        {/* Pagination Controls */}
        {totalPages > 1 && (
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: "20px", gap: "10px" }}>
            <button
              onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
              style={{
                padding: "6px 12px",
                border: "1px solid #ccc",
                borderRadius: "4px",
                background: currentPage === 1 ? "#f5f5f5" : "#fff",
                cursor: currentPage === 1 ? "not-allowed" : "pointer",
                color: currentPage === 1 ? "#999" : "#333"
              }}
            >
              Prev
            </button>
            <span style={{ fontSize: "14px", color: "#555" }}>
              Page {currentPage} of {totalPages}
            </span>
            <button
              onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
              disabled={currentPage === totalPages}
              style={{
                padding: "6px 12px",
                border: "1px solid #ccc",
                borderRadius: "4px",
                background: currentPage === totalPages ? "#f5f5f5" : "#fff",
                cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                color: currentPage === totalPages ? "#999" : "#333"
              }}
            >
              Next
            </button>
          </div>
        )}
      </div>

      {/* Disclaimer Banner */}
      <div style={{
        backgroundColor: "#fff",
        border: "1px solid #eaeaea",
        boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
        borderRadius: "4px",
        padding: "15px 20px",
        marginTop: "30px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        textAlign: "center"
      }}>
        <div style={{ color: "#d4af37", fontSize: "24px", padding: "0 15px" }}>★</div>
        <div style={{ color: "#001964", fontSize: "12px", letterSpacing: "1px", lineHeight: "1.6" }}>
          <div style={{ fontWeight: "600", marginBottom: "2px" }}>THIS CARD HAS NO CASH VALUE ON ITS OWN.</div>
          <div style={{ fontWeight: "600" }}>REWARDS ARE UNLOCKED ONLY WHEN 20 OR 200 UNIQUE CARDS HAVE BEEN REGISTERED.</div>
          <div style={{ fontSize: "11px", marginTop: "4px", color: "#666", fontWeight: "normal" }}>SUBJECT TO THE CAPTAIN TC REWARDS PROGRAMME TERMS AND CONDITIONS.</div>
        </div>
        <div style={{ color: "#d4af37", fontSize: "24px", padding: "0 15px" }}>★</div>
      </div>

    </div>
  );
};

export default CaptainTCGoldCard;
